function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_15379_472060)"
}, React.createElement("path", {
  d: "M22 14C22 18.1422 18.6422 21.5 14.5 21.5C10.3578 21.5 7 18.1422 7 14C7 9.85785 10.3578 6.5 14.5 6.5C18.6422 6.5 22 9.85785 22 14Z",
  fill: "#D9EFFE"
}), React.createElement("path", {
  d: "M14.5 6.5V21.5C18.6422 21.5 22 18.1422 22 14C22 9.85785 18.6422 6.5 14.5 6.5Z",
  fill: "#D9EFFE"
}), React.createElement("path", {
  d: "M21.5726 6.92892C20.6398 5.99615 19.548 5.26678 18.3281 4.76126C17.1085 4.2562 15.8211 4 14.5015 4C13.1819 4 11.8945 4.2562 10.6749 4.76126C9.54529 5.22925 8.52539 5.8895 7.64023 6.72537C7.56912 6.79221 7.49954 6.8598 7.43042 6.92892C7.32071 7.04535 7.26562 7.19412 7.26562 7.3429C7.26562 7.49762 7.32498 7.65234 7.44247 7.76999L9.66003 9.98755L10.0746 9.57312C11.2398 8.40781 12.8534 7.73947 14.5015 7.73947C16.1496 7.73947 17.7632 8.40781 18.9284 9.57312L19.1327 9.77728L21.4687 9.46921L21.7769 7.13324L21.5726 6.92892Z",
  fill: "#FFEF00"
}), React.createElement("path", {
  d: "M10.0731 18.4268C8.90781 17.2617 8.23947 15.6481 8.23947 14C8.23947 12.3519 8.90781 10.7383 10.0731 9.57309L10.2773 9.36877L9.96921 7.03281L7.63873 6.72534C7.56763 6.79218 7.49805 6.85977 7.42892 6.92889C6.49615 7.86166 5.76678 8.95343 5.26126 10.1734C4.7562 11.393 4.5 12.6804 4.5 14C4.5 15.3195 4.7562 16.6069 5.26126 17.8266C5.72925 18.9562 6.3895 19.9761 7.22537 20.8612C7.29221 20.9323 7.3598 21.0019 7.42892 21.071C7.54337 21.1855 7.69336 21.243 7.84335 21.243C7.99335 21.243 8.14334 21.1855 8.25778 21.071L10.4875 18.8414L10.0731 18.4268Z",
  fill: "#00CCFF"
}), React.createElement("path", {
  d: "M21.5723 20.2425L19.3427 18.0125L18.9281 18.4269C17.7629 19.5922 16.1493 20.2605 14.5012 20.2605C12.8531 20.2605 11.2395 19.5922 10.0743 18.4269L9.87 18.2227L7.53403 18.5308L7.22656 20.8613C7.2934 20.9324 7.36099 21.002 7.43011 21.0711C8.36288 22.0038 9.45465 22.7332 10.6746 23.2387C11.8942 23.7438 13.1816 24 14.5012 24C15.8208 24 17.1082 23.7438 18.3278 23.2387C18.9378 22.9859 19.5157 22.6774 20.0578 22.3153C20.5997 21.9532 21.1058 21.5375 21.5723 21.0711C21.8011 20.8422 21.8011 20.4711 21.5723 20.2425Z",
  fill: "#FF4359"
}), React.createElement("path", {
  d: "M21.743 20.6566C21.743 20.8066 21.6855 20.9566 21.5711 21.0711C21.502 21.1402 21.4324 21.2078 21.3613 21.2746C20.4761 22.1105 19.4562 22.7708 18.3266 23.2387C17.107 23.7438 15.8196 24 14.5 24V20.2605C16.1481 20.2605 17.7617 19.5922 18.9269 18.4269L19.3415 18.0125L21.5711 20.2425C21.6855 20.357 21.743 20.5067 21.743 20.6566Z",
  fill: "#E2095A"
}), React.createElement("path", {
  d: "M23.738 10.1735C23.4852 9.56342 23.1766 8.98557 22.8145 8.44342C22.4525 7.90158 22.0368 7.39545 21.5703 6.92899C21.3415 6.7001 20.9704 6.7001 20.7418 6.92899L18.5117 9.1586L18.9261 9.57318C20.0915 10.7383 20.7598 12.352 20.7598 14.0001C20.7598 15.6482 20.0915 17.2618 18.9261 18.4269L18.722 18.6313L19.0301 20.9672L21.3605 21.2747C21.4316 21.2079 21.5012 21.1403 21.5703 21.0711C22.5031 20.1384 23.2325 19.0466 23.738 17.8267C24.2431 16.607 24.4993 15.3196 24.4993 14.0001C24.4993 12.6805 24.2431 11.3931 23.738 10.1735Z",
  fill: "#14DB72"
}), React.createElement("path", {
  d: "M11.375 14C11.375 13.6764 11.6373 13.4141 11.9609 13.4141H17.0391C17.3627 13.4141 17.625 13.6764 17.625 14C17.625 14.3236 17.3627 14.5859 17.0391 14.5859H11.9609C11.6373 14.5859 11.375 14.3236 11.375 14Z",
  fill: "url(#paint0_linear_15379_472060)"
}), React.createElement("path", {
  d: "M12.2344 11.6562C12.2344 11.3326 12.4967 11.0703 12.8203 11.0703H16.1797C16.5033 11.0703 16.7656 11.3326 16.7656 11.6562C16.7656 11.9799 16.5033 12.2422 16.1797 12.2422H12.8203C12.4967 12.2422 12.2344 11.9799 12.2344 11.6562Z",
  fill: "url(#paint1_linear_15379_472060)"
}), React.createElement("path", {
  d: "M12.5469 16.3438C12.5469 16.0201 12.8092 15.7578 13.1328 15.7578H15.8672C16.1908 15.7578 16.4531 16.0201 16.4531 16.3438C16.4531 16.6674 16.1908 16.9297 15.8672 16.9297H13.1328C12.8092 16.9297 12.5469 16.6674 12.5469 16.3438Z",
  fill: "url(#paint2_linear_15379_472060)"
}), React.createElement("path", {
  d: "M18.9269 9.57312L19.1313 9.77744L21.467 9.46906L21.7755 7.13339L21.5711 6.92892C20.6382 5.996 19.5465 5.26678 18.3268 4.76141C17.1068 4.2562 15.8194 4 14.5 4V7.73932C16.1481 7.73932 17.7616 8.40781 18.9269 9.57312Z",
  fill: "#FFC600"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15379_472060",
  x1: 17.7503,
  y1: 13.4141,
  x2: 16.8007,
  y2: 16.3465,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("linearGradient", {
  id: "paint1_linear_15379_472060",
  x1: 16.8565,
  y1: 11.0703,
  x2: 15.65,
  y2: 13.7714,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("linearGradient", {
  id: "paint2_linear_15379_472060",
  x1: 16.5314,
  y1: 15.7578,
  x2: 15.208,
  y2: 18.3121,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("clipPath", {
  id: "clip0_15379_472060"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(4.5 4)"
})));

var SvgTonghopklActive = function SvgTonghopklActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTonghopklActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tonghopkl_active.4c1d4174.svg";
export { ForwardRef as ReactComponent };